import React, { useEffect, useState } from 'react';

/**
 * PinterestAds: Pinterest reklamlarının yerleşimleri (Göz At / Ara / Tümü),
 * beş kampanya hedefi ve sekiz reklam formatı — görsel ağırlıklı kısa belge.
 * Route: /r/pinterest-ads (sidebar YOK, tam ekran belge)
 *
 * Kardeş belge: /r/pinterest-formatlari (Pin · Fikir Pini · Pano · Kolaj).
 * Görselleri o belgeyle ORTAK klasörden çekiyor:
 * api.glowytics.com/pixel/pinterest/ (backend public/pinterest/).
 * Oradan dosya silerken iki belgeyi de kontrol et.
 *
 * 🔑 "PDF olarak kaydet" düğmesi belgenin İÇİNDE — iframe kendi `window.print()`ini
 * çağırır. Dış sayfadan Ctrl+P iframe'i tek sayfaya kırpar; düğmeyi kaldırma.
 */
export default function PinterestAds() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./pinterestAdsHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#0B1020">Belge yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  if (!html) return <div style={{ ...fill, background: '#F5F6FA' }} />;

  return (
    <iframe
      title="Pinterest Ads · Yerleşimler, Hedefler, Formatlar"
      srcDoc={html}
      style={fill}
    />
  );
}
